import { trackSalesAssistantEvent } from "@/lib/analytics";
import type { AssistantPageType } from "./config";

export function trackAssistantEvent(
  event: "chat_triggered_15s" | "chat_open" | "chat_dismissed" | "question_asked" | "service_recommended" | "lead_captured" | "booking_started" | "booking_time_selected" | "booking_completed" | "score_routed",
  params: Record<string, string | number | boolean | undefined>,
): void {
  trackSalesAssistantEvent(event, params);
}

export function triggerAssistantEvent(pageType: AssistantPageType, pagePath: string): void {
  trackAssistantEvent("chat_triggered_15s", {
    page_type: pageType,
    page_path: pagePath,
    trigger_seconds: 15,
    device: window.innerWidth < 768 ? "mobile" : "desktop",
  });
}
